import { NavigationProp, useNavigation } from "@react-navigation/native";
import { usePreviewMode } from "../../../contexts/PreviewModeContext";
import type { RootStackParamList } from "../../../navigation/navigation.types";
import PreviewModeBanner from "../../../components/adminDashboard/PreviewModeBanner";
const PreviewModeBannerContainer = () => {
  const navigation = useNavigation<NavigationProp<RootStackParamList>>();
  const { previewReturnInfo, exitPreviewMode } = usePreviewMode();

  if (!previewReturnInfo) return null;

  const handleBackToAdmin = () => {
    exitPreviewMode();
    navigation.navigate("Course Information", {
      courseId: previewReturnInfo.courseId,
      courseName: previewReturnInfo.courseName,
    });
  };

  return <PreviewModeBanner courseName={previewReturnInfo.courseName} onBackToAdmin={handleBackToAdmin} />;
};

export default PreviewModeBannerContainer;
